import React, { useContext, useEffect } from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Layout } from 'antd';
import { useMenu } from '@/contexts/Menu';
import { topTitleContext } from '@/contexts/TopTitle';
import { Title } from './styles';
import AssumingBox from '../AssumingBox';
import AvatarMenu from '../AvatarMenu';

const { Header } = Layout;

type Props = {
    children: React.ReactNode;
};

const ContentUI: React.FC<Props> = ({ children }) => {
    const { isCollapsed, setCollapsed } = useMenu();

    const { title, titleValue } = useContext(topTitleContext);

    useEffect(() => {
        if (!title) titleValue(title);
    }, [title]);

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header
                style={{
                    padding: '0px 10px',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <Button
                    type="text"
                    icon={
                        isCollapsed ? (
                            <MenuUnfoldOutlined />
                        ) : (
                            <MenuFoldOutlined />
                        )
                    }
                    onClick={() => setCollapsed(!isCollapsed)}
                />
                <Title>{title}</Title>
                <AssumingBox />
                <AvatarMenu />
            </Header>
            {children}
        </Layout>
    );
};

export default ContentUI;
